<section class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h1>Icon List</h1>

      <h2>Home page</h2>

      <ul>
        <li><i class="icon icon-logo-header-lg"></i></li>
        <li><i class="icon icon-logo-header-sm"></i></li>
        <li><i class="icon icon-logo-footer-lg"></i></li>
        <li><i class="icon icon-logo-footer-sm"></i></li>

        <li><i class="icon icon-home"></i></li>
        <li><i class="icon icon-qa"></i></li>
        <li><i class="icon icon-print"></i></li>

        <li><i class="icon icon-magnifier"></i></li>
        <li><i class="icon icon-reset-round"></i></li>
        <li><i class="icon icon-reset"></i></li>
        <li><i class="icon icon-close"></i></li>

        <li><i class="icon icon-social-media-fb"></i></li>
        <li><i class="icon icon-social-media-youtube"></i></li>
        <li><i class="icon icon-social-media-twitter"></i></li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h2>Development page</h2>

      <ul>
        <li><i class="icon icon-location-lg"></i></li>
        <li><i class="icon icon-save-pdf"></i></li>

        <li><i class="icon icon-capital-5y-lg"></i></li>
        <li><i class="icon icon-capital-5y-sm"></i></li>
        <li><i class="icon icon-capital-20y-lg"></i></li>
        <li><i class="icon icon-capital-20y-sm"></i></li>

        <li><i class="icon icon-back"></i></li>
        <li><i class="icon icon-project-placeholder-lg"></i></li>
        <li><i class="icon icon-project-placeholder-md"></i></li>
        <li><i class="icon icon-hiring-information"></i></li>

        <li><i class="icon icon-capital-20y-sm"></i></li>
        <li><i class="icon icon-capital-20y-sm"></i></li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h2>Project page</h2>

      <ul>
        <li><i class="icon icon-location-sm"></i></li>
        <li><i class="icon icon-caret-double"></i></li>

        <li><i class="icon icon-project-scope-lg"></i></li>
        <li><i class="icon icon-project-scope-sm"></i></li>
        <li><i class="icon icon-project-update-lg"></i></li>

        <li><i class="icon icon-project-investment-lg"></i></li>
        <li><i class="icon icon-project-investment-sm"></i></li>
      </ul>
    </div>
  </div>
</section>
